import * as actions from '../Constants/actionTypes';

export const hideLoadingAction = () => ({
    type: actions.AT_LOADING_HIDE
});

export const showLoadingAction = () => ({
    type: actions.AT_LOADING_SHOW
});